import React, { useState, useEffect, FC } from 'react';
import './forecast-table-row.scss';
import { Button } from 'primereact/button';
import StockTableCountCell from '../stock-table-count-cell/stock-table-count-cell';
import { Checkbox } from 'primereact/checkbox';

export interface ForecastTableRowProps {
    object: any;
    headers: any[];
    checked: boolean;
    setChecked: (checked: boolean, id: string) => void;
}

const ForecastTableRow:FC<ForecastTableRowProps> = (props) => {
    const [stock, setStock] = useState(props);

    return (
        <div className="forecast-table-row">
            <Checkbox onChange={e => props.setChecked(e.checked, props.object.id)} checked={props.checked}></Checkbox>
            {props.headers.map((header, index) => {
                    return <div className={`forecast-table-row__label ${header.style}`}>{props.object[header.field]}</div>
            })}
        </div>
    );
}
         
export default ForecastTableRow;